module.exports = __webpack_public_path__ + "static/Konditor Seite 1-89d2a556a7706b1f2f043c629883a02a.jpg";